<template>
  <div class="container">
    <div class="list">
      <div class="list-search">
        <el-input
          v-model="searchRole"
          :placeholder="$t('system::rbac::搜索角色名称')"
          @blur="getRoleList()"
          @clear="getRoleList()"
          clearable
        ></el-input>
        <el-button type="primary" style="margin-left: 8px" @click="toAdd">
          {{ $t('system::rbac::新增角色') }}
        </el-button>
      </div>
      <ul class="role-list">
        <li
          v-for="item in roleList"
          :key="item.roleId"
          class="list-item"
          :class="{ active: activeRole.roleId === item.roleId }"
          @click="changeRole(item)"
        >
          <div style="display: flex; align-items: center">
            <div class="label">{{ item.roleName }}</div>
            <span class="num">（{{ item.usersNum }}）</span>
          </div>
          <div>
            <i class="el-icon-edit" @click.stop="edit(item)"></i>
            <i class="el-icon-delete-solid" @click.stop="remove(item)"></i>
          </div>
        </li>
      </ul>
    </div>
    <div class="wrap">
      <div style="display: flex; justify-content: space-between; align-items: center">
        <div>
          <el-button :type="activeTab === 'role' ? 'primary' : ''" @click="changeType('role')">
            {{ $t('system::rbac::员工角色分配') }}
          </el-button>
          <el-button
            :type="activeTab === 'auth' ? 'primary' : ''"
            @click="changeType('auth')"
            :disabled="!roleList.length"
          >
            {{ $t('system::rbac::角色权限设置') }}
          </el-button>
        </div>
        <div class="search">
          <el-input
            style="width: 200px; margin-right: 10px"
            :placeholder="$t('system::rbac::搜索姓名或手机号码')"
            v-model="searchValue"
          >
            <el-button slot="append" icon="el-icon-search" type="primary" @click="searchForRole"></el-button>
          </el-input>
          <el-button
            type="primary"
            @click="$refs.role.isShowAdd = true"
            icon="el-icon-plus"
            :disabled="!activeRole.roleId || activeTab !== 'role'"
          >
            {{ $t('system::rbac::添加员工') }}
          </el-button>
        </div>
      </div>
      <div class="wrap-content">
        <component :is="activeTab" :role="activeRole" :ref="activeTab" @refresh="getRoleList(true)"></component>
      </div>
    </div>
    <AddRole v-model="isShowAdd" :drawRow="drawRow" @refresh="getRoleList(true)"></AddRole>
  </div>
</template>

<script>
import AddRole from './components/add-role.vue'
import role from './role.vue'
import auth from './auth.vue'
import { getRoleList, removeRole } from '@/server/system'
export default {
  components: { role, auth, AddRole },
  data() {
    return {
      activeTab: 'role',
      isShowAdd: false,
      searchRole: '',
      searchValue: '',
      roleList: [],
      activeRole: {},
      drawRow: {
        type: 'add',
        data: {},
      },
    }
  },
  mounted() {
    this.getRoleList()
  },
  methods: {
    async getRoleList(refresh) {
      const data = await getRoleList({
        pageNum: 1,
        pageSize: 10000,
        systemId: 3,
        roleName: this.searchRole,
        keywords: this.searchValue,
      })
      if (data.data.code === this.$code) {
        this.roleList = data.data.data.items
        if ((!refresh || !this.activeRole.roleId) && this.roleList[0]) {
          this.changeRole(this.roleList[0])
        }
        this.$refs[this.activeTab].search(this.searchValue)
      }
    },
    changeType(val) {
      if (this.activeTab === val) {
        return
      }
      this.activeTab = val
    },
    changeRole(role) {
      console.log(role)
      if (this.activeRole.roleId === role.roleId) {
        return
      }
      this.activeRole = role
      this.$nextTick(() => {
        this.$refs[this.activeTab].search(this.searchValue)
      })
    },
    toAdd() {
      this.drawRow = {
        type: 'add',
      }
      this.isShowAdd = true
    },
    edit(item) {
      this.drawRow = {
        type: 'edit',
        data: item,
      }
      this.isShowAdd = true
    },
    remove(item) {
      if (item.usersNum) {
        this.$message.warning(this.$t('system::rbac::role_waring'))
      } else {
        this.$confirm(
          `<div>${this.$t('system::rbac::role_delete_title')}</div><div>${this.$t(
            'system::rbac::role_delete_tip'
          )}</div>`,
          this.$t('system::rbac::删除角色'),
          {
            confirmButtonText: this.$t('system::common::btn::confirm'),
            cancelButtonText: this.$t('system::common::btn::cancel'),
            dangerouslyUseHTMLString: true,
          }
        ).then(() => {
          this.removeRole(item.roleId)
        })
      }
    },
    async removeRole(id) {
      const data = await removeRole(id)
      if (data.data.code === this.$code) {
        this.$message.success(this.$t('system::tip::delete_success'))
        this.getRoleList()
      }
    },
    searchForRole() {
      this.getRoleList(true)
      // this.$refs[this.activeTab].search(this.searchValue)
    },
  },
}
</script>

<style lang="scss" scoped>
.el-icon-delete-solid,
.el-icon-edit {
  color: #999;
  cursor: pointer;
  display: none;
  margin-left: 16px;
}
.active {
  background: rgba(54, 109, 255, 0.1) !important;
  color: #0560fd !important;
  .num {
    color: #0560fd !important;
  }
}
.container {
  display: flex;
  .list {
    flex: 0 0 280px;
    height: 725px;
    border-radius: 6px;
    margin-right: 16px;
    background-color: #ffffff;
    padding: 24px;
    overflow: hidden;
    .list-search {
      margin-bottom: 16px;
      display: flex;
    }
    .role-list {
      height: calc(100% - 40px);
      overflow: auto;
      .list-item {
        padding: 16px;
        background: #f4f4f4;
        border-radius: 4px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 14px;
        cursor: pointer;
        .label {
          font-weight: bold;
          display: inline-block;
          max-width: 140px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .num {
          color: #999;
        }
      }
      .list-item + .list-item {
        margin-top: 16px;
      }
    }
    .list-item:hover {
      background: rgba(54, 109, 255, 0.1) !important;
      color: #0560fd !important;
      .num {
        color: #0560fd !important;
      }
      .el-icon-delete-solid,
      .el-icon-edit {
        display: inline-block;
      }
    }
  }
  .wrap {
    flex: 1;
    display: flex;
    flex-direction: column;
    .wrap-content {
      margin-top: 16px;
      flex: 1;
      padding: 24px;
      background-color: #fff;
      border-radius: 6px;
    }
  }
}
.search {
  /deep/.el-input-group__append {
    padding: 0 12px;
    background: #0560fd !important;
    color: #fff !important;
    border: 1px solid #0560fd;
  }
}
</style>
